// extracted by mini-css-extract-plugin
export default {"container":"HaMJ9Y","floatingText":"JIsV1i"};